/**
 * @title:
 * @fileName: index
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/7/21 10:08
 * @modified By：
 * @version:     1.0$
 * @description: TODO
 */
import ExportDownloads from "@/api/urls/downloads/ExportDownloads";
class Downloads {
    constructor(hostname, path = '/api') {
        this._api = hostname + path
        this._hostname = hostname
        this._path = path
        this._exportDownloads = new ExportDownloads(hostname)
    }

    //桥梁定期检查
    get ExportDownloads (){
        return this._exportDownloads
    }

}
export default Downloads
